import React from 'react';
export function FearNarrative() {
  return <section className="bg-white py-20 px-4" data-id="element-21">
      <div className="max-w-3xl mx-auto" data-id="element-22">
        <div className="prose prose-lg md:prose-xl text-zinc-800" data-id="element-23">
          <p className="mb-6" data-id="element-24">
            Most families in U.S. cities and suburbs are not prepared for even a
            24-hour blackout.
            <br data-id="element-25" />
            <br data-id="element-26" />
            <strong data-id="element-27">No Power</strong>
            <br data-id="element-28" />
            <strong data-id="element-29">No Water</strong>
            <br data-id="element-30" />
            <strong data-id="element-31">No Internet</strong>
            <br data-id="element-32" />
            <br data-id="element-33" />
            And no clear plan. <br data-id="element-34" />
            And when you have kids depending on you…. <br data-id="element-35" />
            <strong data-id="element-36">“figuring it out in the moment”</strong> is not a strategy.
          </p>
          <p className="mb-6" data-id="element-37">
            <strong data-id="element-38">This is for you if:</strong>
            <br data-id="element-39" />
            <br data-id="element-40" />
            • You live in a city, suburb, or apartment <br data-id="element-41" />
            • You have kids or family depending on you <br data-id="element-42" />
            • You want to be prepared without extreme survival tactics <br data-id="element-43" />
            • You don’t have a bunker or thousands to spend <br data-id="element-44" />
            • You just want a simple, clear plan that works
            <br data-id="element-45" />
          </p>
          <p className="mb-6" data-id="element-46">
            <strong data-id="element-47">Now imagine this happening tonight…</strong>
            <br data-id="element-48" />
          </p>
          <p className="font-montserrat font-bold text-2xl md:text-3xl text-black mb-6 leading-snug" data-id="element-49">
            It's 2:14 AM. The lights flicker and go dark.
          </p>
          <p className="mb-6" data-id="element-50">
            <strong data-id="element-51">You reach for your phone—No Signal...</strong>
            <br data-id="element-52" />
          </p>
          <p className="mb-6" data-id="element-53">
            You reach for your phone—<strong data-id="element-54">No Signal</strong>. You try the
            faucet—<strong data-id="element-55">Nothing but a dry hiss</strong>. You look out the
            window and see your entire city in total, heavy silence.
          </p>

          <p className="font-montserrat font-bold text-xl md:text-2xl text-brand-red mb-8" data-id="element-56">
            What is your very next move?
          </p>

          <p className="mb-6" data-id="element-57">
            If your answer is "wait for the government," you are gambling with
            your family's life. In 2026, the U.S. power grid, supply chains, and
            urban stability are thinner than they've ever been.
          </p>

          <p className="mb-8" data-id="element-58">
            Most preparedness advice is built for people with land, large
            budgets, or off-grid setups. This system was built for normal
            families living in cities, suburbs, and apartments who need a
            realistic plan fast.
          </p>

          <div className="border-l-4 border-brand-orange pl-6 py-2 italic text-zinc-600" data-id="element-59">
            Most survival systems were built for mountain men with bunkers. We
            built this for the father in Austin who works 9-to-5 and needs his
            family safe by Sunday.
          </div>
        </div>
      </div>
    </section>;
}